module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av645-5ca3bf057b73cc6544666a79791453e7.jpg";